export default "__VITE_ASSET__335bbb5d__"